<template>
  <v-select
    id="urs-select"
    v-model ="filter.id_unidade_regional"
    item-text ="nomeRegiao"
    item-name ="id_unidade_regional"
    item-value ="id_unidade_regional"
    :items="urs"
    label ="Leitura"
    placeholder ="Leitura"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
  >
    <template slot="no-data">
      Nenhuma Leitura
    </template>
  </v-select>
</template>

<script>
import { salaIndicadorLeitura } from '../API/salaIndicadoresLeitura'
import { mapActions } from 'vuex'

export default {
  name: 'AppUrCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadUrs()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadUrs () {
      salaIndicadorLeitura.getByUf(this.$store.state.uf)
        .then(resp => {
          this.urs = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      urs: []
    }
  }
}
</script>
